var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloudPlaylist = function SvgCloudPlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 475 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.921 55.533c-.203-.644-.414-1.314-.603-1.608C406.296 38.36 341.651 12.95 319.096 40.3l-3.315-2.265C278.112 12.282 261.438.883 203.985.505 144.874.115 118.04 40.3 118.04 40.3c-2.534-9.077-11.185-19.73-25.144-19.951-24.027-.381-40.739 10.643-49.719 23.74C28.707 25.438 2.59 49.6.861 56.5h416.381c-.101-.27-.21-.615-.321-.967ZM417.828 56.5h56.788c3.78-29.824-40.088-44.055-56.788 0Z",
    fill: "currentColor"
  })));
};

export default SvgCloudPlaylist;